/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Debt_Payment_Leftover_CreditInputs */

const vi_customer_debt_payment_leftover_credit = /** @type {(inputs: Customer_Debt_Payment_Leftover_CreditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sẽ thành credit trả trước`)
};

/**

* @param {Customer_Debt_Payment_Leftover_CreditInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_debt_payment_leftover_credit = /** @type {((inputs?: Customer_Debt_Payment_Leftover_CreditInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Debt_Payment_Leftover_CreditInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_debt_payment_leftover_credit(inputs)
});